import React, { Component } from 'react'
import moment from 'moment'
import { Box } from '../../styles.style'
import { MaskBirthday } from '../masks/masks'
import { ErrorMessage, getIn } from 'formik'
import { MuvicardService } from '../../../../services/muvicard.service'

class Birthday extends Component {
	constructor(props) {
		super(props)
		moment.locale('pt-br')
		this.state = {
			birth: ''
		}
	}

	componentDidMount() {
		const { setFieldValue, userData } = this.props
		if (userData) {
			const { birthDate } = userData
			if (birthDate) {
				setFieldValue('birthDate', birthDate)
			}
			MuvicardService.proposalStepRegister('Data de nascimento', 'Acesso')
		}
	}

	nextPage = () => {
		const { userData, updateUserData } = this.props
		let newUserData = { ...userData }
		newUserData.birthDate = this.props.values.birthDate
		updateUserData(newUserData)

		const birthDate = moment(this.props.values.birthDate, 'DD/MM/YYYY')
		const obj = { birthDate }

		MuvicardService.sendPersonalData(obj).then(data => {
			if (data.success) {
				MuvicardService.proposalStepRegister(
					'Data de nascimento',
					'Atualização'
				)
				this.props.nextStep()
			}
		})
	}
	setBirthday = e => {
		this.setState({ birth: MaskBirthday(e.target.value) })
	}

	render() {
		const {
			handleBlur,
			handleChange,
			prevStep,
			values,
			errors,
			touched,
			setFieldValue
		} = this.props
		return (
			<Box className="box-cep">
				<div className="field">
					<header>
						<h5>Agora precisamos de sua data de nascimento</h5>
					</header>

					<div>
						<input
							autoComplete="off"
							className={
								getIn(errors, 'birthDate') &&
								getIn(touched, 'birthDate')
									? 'field-error input-big'
									: 'input-big'
							}
							type="text"
							placeholder="Data de nascimento"
							id="birthDate"
							name="birthDate"
							value={this.state.birth || values.birthDate}
							maxLength="10"
							onChange={e => {
								this.setBirthday(e)
								handleChange(e)
								setFieldValue('birthDate', MaskBirthday(e.target.value))
							}}
							onBlur={handleBlur}
						/>
						<ErrorMessage
							component="div"
							name="birthDate"
							className="msg-error"
						/>
					</div>
				</div>

				<footer className="footer">
					<button
						className="button transparent"
						type="button"
						onClick={() => prevStep()}>
						Voltar
					</button>
					<button
						disabled={
							!values.birthDate ||
							values.birthDate.length < 8 ||
							(errors.birthDate && touched.birthDate)
						}
						className={
							errors.birthDate && touched.birthDate
								? 'disabled button'
								: 'button'
						}
						type="button"
						onClick={() => this.nextPage()}>
						Próximo
					</button>
				</footer>
			</Box>
		)
	}
}

export default Birthday
